import { render, staticRenderFns } from "./CloseAllProfiles.vue?vue&type=template&id=5c7a5d52&"
import script from "./CloseAllProfiles.vue?vue&type=script&lang=js&"
export * from "./CloseAllProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7a5d52')) {
      api.createRecord('5c7a5d52', component.options)
    } else {
      api.reload('5c7a5d52', component.options)
    }
    module.hot.accept("./CloseAllProfiles.vue?vue&type=template&id=5c7a5d52&", function () {
      api.rerender('5c7a5d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/CloseAllProfiles.vue"
export default component.exports